import { Add, AddCircle, Delete, Edit, FirstPage, Info, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@mui/icons-material';
import { Box, IconButton, ListItemIcon, MenuItem, TableCell, TableRow, styled, tableCellClasses } from '@mui/material';
import { Link } from 'react-router-dom';

function CustomEncrypt(text) {
    let key = "6Le0DgMTAs";
    const CryptoJS = require('crypto-js');
    var encryptedString = CryptoJS.AES.encrypt(text, key).toString();

    return encryptedString;
}

function CustomDescrypt(text) {
    let key = "6Le0DgMTAs";
    const CryptoJS = require('crypto-js');

    let bytes = CryptoJS.AES.decrypt(text, key);
    let data = bytes.toString(CryptoJS.enc.Utf8);

    return data;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

function TablePaginationActions(props) {
    // const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                <FirstPage />
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                <LastPage />
            </IconButton>
        </Box>
    );
}

const getMenuItem = (params, closeMenu, handleOpenAddChild, setParentData, setEditData, handleOpenEdit, deleteData, opd, baseUrl, allowEdit) => {
    let output;
    switch (params.ket) {
        case 'PROGRAM':
            output = [
                // row.original.ket === 'Program' &&
                <MenuItem
                    key={0}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    component={Link}
                    to={baseUrl+ '/detail-program'}
                    state={{
                        program: params,
                        opd: opd
                    }}
                >
                    <ListItemIcon>
                        <Info color={params.ket === '' ? 'disabled' : 'info'} />
                    </ListItemIcon>
                    Detail Program
                </MenuItem>,
                allowEdit && 
                <MenuItem
                    key={1}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        handleOpenAddChild()
                        setParentData(params)
                    }}
                >
                    <ListItemIcon>
                        <Add color={params.ket === '' ? 'disabled' : 'primary'} />
                    </ListItemIcon>
                    Tambah Kegiatan
                </MenuItem>,
                allowEdit && <MenuItem
                    key={2}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        setEditData(params)
                        handleOpenEdit()
                        // handleOpenAddChild()
                        // setParentData(params)
                    }}
                >
                    <ListItemIcon>
                        <Edit color={params.ket === '' ? 'disabled' : 'success'} />
                    </ListItemIcon>
                    Edit Program
                </MenuItem>,
                allowEdit &&  <MenuItem
                    key={3}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        deleteData(params.id, params.ket, params.uraian)
                    }}
                >
                    <ListItemIcon>
                        <Delete color={params.ket === '' ? 'disabled' : 'error'} />
                    </ListItemIcon>
                    Hapus Program
                </MenuItem>
            ]
            break;

        case 'KEGIATAN':
            output = [
                <MenuItem
                    key={0}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    component={Link}
                    to={baseUrl+ '/detail-kegiatan'}
                    state={{
                        program: params,
                        opd: opd
                    }}
                >
                    <ListItemIcon>
                        <Info color={params.ket === '' ? 'disabled' : 'info'} />
                    </ListItemIcon>
                    Detail Kegiatan
                </MenuItem>,
                allowEdit && <MenuItem
                    key={1}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        handleOpenAddChild()
                        setParentData(params)
                    }}
                >
                    <ListItemIcon>
                        <Add color={params.ket === '' ? 'disabled' : 'primary'} />
                    </ListItemIcon>
                    Tambah Sub Kegiatan
                </MenuItem>,
                allowEdit && <MenuItem
                    key={2}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        setEditData(params)
                        handleOpenEdit()
                    }}
                >
                    <ListItemIcon>
                        <Edit color={params.ket === '' ? 'disabled' : 'success'} />
                    </ListItemIcon>
                    Edit Kegiatan
                </MenuItem>,
                allowEdit && <MenuItem
                    key={3}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        deleteData(params.id, params.ket, params.uraian)
                    }}
                >
                    <ListItemIcon>
                        <Delete color={params.ket === '' ? 'disabled' : 'error'} />
                    </ListItemIcon>
                    Hapus Kegiatan
                </MenuItem>
            ]
            break;

        default:
            output = [
                <MenuItem
                    key={0}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    component={Link}
                    to={baseUrl+'/rincian-belanja'}
                    state={{
                        subKegiatan: params,
                        opd: opd
                    }}
                >
                    <ListItemIcon>
                        <Info color={params.ket === '' ? 'disabled' : 'info'} />
                    </ListItemIcon>
                    Rincian Belanja
                </MenuItem>,
                allowEdit && <MenuItem
                    key={1}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        setEditData(params)
                        handleOpenEdit()
                    }}
                >
                    <ListItemIcon>
                        <Edit color={params.ket === '' ? 'disabled' : 'success'} />
                    </ListItemIcon>
                    Edit SubKegiatan
                </MenuItem>,
                allowEdit && <MenuItem
                    key={2}
                    sx={{ m: 0 }}
                    disabled={!params.ket}
                    onClick={() => {
                        closeMenu()
                        deleteData(params.id, params.ket, params.uraian)
                    }}
                >
                    <ListItemIcon>
                        <Delete color={params.ket === '' ? 'disabled' : 'error'} />
                    </ListItemIcon>
                    Hapus SubKegiatan
                </MenuItem>
            ]
            break;

    }
    return output
}

export { CustomEncrypt, CustomDescrypt, StyledTableCell, StyledTableRow, TablePaginationActions, getMenuItem }